import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListStartedAtCell } from './emsp-bo-charging-session-list-started-at.cell';
import { EmspBoChargingSessionListStartedAtHeader } from './emsp-bo-charging-session-list-started-at.header';

export const EmspBoChargingSessionListStartedAtColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['startedAt']
> = {
  enableSorting: true,
  header: EmspBoChargingSessionListStartedAtHeader,
  cell: EmspBoChargingSessionListStartedAtCell,
  meta: { maxWidth: '165px', width: '160px', minWidth: '60px' },
};
